import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner, Alert, Table, Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { pageService, timetableService, resultsService, circularsService } from '../services/api';
import config from '../config';
import ResultsAnalysis from '../components/ResultsAnalysis';
import './ContentPage.css';

const ContentPage = () => {
  const location = useLocation();
  const slug = location.pathname.slice(1); // Remove leading '/'
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [timetables, setTimetables] = useState([]);
  const [results, setResults] = useState([]);
  const [circulars, setCirculars] = useState([]);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        if (slug === 'timetables') {
          const timetableResponse = await timetableService.getAllTimetables();
          setTimetables(timetableResponse.data.timetables);
        } else if (slug === 'results') {
          const resultsResponse = await resultsService.getPublicResults();
          setResults(resultsResponse.data.results);
        } else if (slug === 'circulars') {
          const circularsResponse = await circularsService.getPublicCirculars();
          setCirculars(circularsResponse.data.circulars);
        } else {
          const response = await pageService.getPageBySlug(slug);
          setPage(response.data.page);
        }
      } catch (err) {
        setError('Failed to load page content');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [slug]);

  if (loading) return <Spinner animation="border" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <Container className="my-5">
      {slug === 'timetables' ? (
        <>
          <Row>
            <Col>
              <h1 className="mb-4">Time Tables</h1>
            </Col>
          </Row>
          <Row>
            <Col md={8}>
              <div className="content-area">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Academic Year</th>
                      <th>Semester</th>
                      <th>Timetable</th>
                    </tr>
                  </thead>
                  <tbody>
                    {timetables.map((timetable) => (
                      <tr key={timetable.id}>
                        <td>{timetable.academic_year}</td>
                        <td>{timetable.semester}</td>
                        <td>
                          <Button
                            size="sm"
                            variant="primary"
                            onClick={() => window.open(`${config.UPLOAD_BASE_URL}/${timetable.file_path}`, '_blank')}
                          >
                            View
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {timetables.length === 0 && (
                  <p className="text-muted">No timetables available.</p>
                )}
              </div>
            </Col>
            <Col md={4}>
              <div className="sidebar">
                <h3 className="sidebar-title">Quick Links</h3>
                <section className="quick-links-widget">
                  <a href="http://203.129.197.28/students/studentlogin.aspx" target="_blank" className="quick-link-btn primary">UG Student Portal Login</a>
                  <a href="http://203.129.197.28//STUDENTS/PG/LOGIN.ASPX" target="_blank" className="quick-link-btn secondary">PG Student Portal Login</a>
                  <a href="#" className="quick-link-btn brown-btn">Student online Services</a>
                  <a href="#" className="quick-link-btn brown-btn">Course Structure</a>
                  <a href="#" className="quick-link-btn brown-btn">Evaluation Process</a>
                </section>
               <ResultsAnalysis />
              </div>
            </Col>
          </Row>
        </>
      ) : slug === 'results' ? (
        <>
          <Row>
            <Col>
              <h1 className="mb-4">Results</h1>
            </Col>
          </Row>
          <Row>
            <Col md={8}>
              <div className="content-area">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Academic Year</th>
                      <th>Month / Semester</th>
                      <th>Results</th>
                    </tr>
                  </thead>
                  <tbody>
                    {results.map((result) => (
                      <tr key={result.id}>
                        <td>{result.academic_year}</td>
                        <td>{result.month_semester}</td>
                        <td>
                          <Button
                            size="sm"
                            variant="primary"
                            onClick={() => window.open(`${config.UPLOAD_BASE_URL}/${result.file_path}`, '_blank')}
                          >
                            View
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {results.length === 0 && (
                  <p className="text-muted">No results available.</p>
                )}
              </div>
            </Col>
            <Col md={4}>
              <div className="sidebar">
                <h3 className="sidebar-title">Quick Links</h3>
                <section className="quick-links-widget">
                  <a href="http://203.129.197.28/students/studentlogin.aspx" target="_blank" className="quick-link-btn primary">UG Student Portal Login</a>
                  <a href="http://203.129.197.28//STUDENTS/PG/LOGIN.ASPX" target="_blank" className="quick-link-btn secondary">PG Student Portal Login</a>
                  <a href="#" className="quick-link-btn brown-btn">Student online Services</a>
                  <a href="#" className="quick-link-btn brown-btn">Course Structure</a>
                  <a href="#" className="quick-link-btn brown-btn">Evaluation Process</a>
                </section>
                <ResultsAnalysis />
              </div>
            </Col>
          </Row>
        </>
      ) : slug === 'circulars' ? (
        <>
          <Row>
            <Col>
              <h1 className="mb-4">Circulars</h1>
            </Col>
          </Row>
          <Row>
            <Col md={8}>
              <div className="content-area">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Academic Year</th>
                      <th>Session</th>
                      <th>Semester</th>
                      <th>Exam Notification</th>
                    </tr>
                  </thead>
                  <tbody>
                    {circulars.map((circular) => (
                      <tr key={circular.id}>
                        <td>{circular.academic_year}</td>
                        <td>{circular.session}</td>
                        <td>{circular.semester}</td>
                        <td>
                          <Button
                            size="sm"
                            variant="primary"
                            onClick={() => window.open(`${config.UPLOAD_BASE_URL}/${circular.file_path}`, '_blank')}
                          >
                            View
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {circulars.length === 0 && (
                  <p className="text-muted">No circulars available.</p>
                )}
              </div>
            </Col>
            <Col md={4}>
              <div className="sidebar">
                <h3 className="sidebar-title">Quick Links</h3>
                <section className="quick-links-widget">
                  <a href="http://203.129.197.28/students/studentlogin.aspx" target="_blank" className="quick-link-btn primary">UG Student Portal Login</a>
                  <a href="http://203.129.197.28//STUDENTS/PG/LOGIN.ASPX" target="_blank" className="quick-link-btn secondary">PG Student Portal Login</a>
                  <a href="#" className="quick-link-btn brown-btn">Student online Services</a>
                  <a href="#" className="quick-link-btn brown-btn">Course Structure</a>
                  <a href="#" className="quick-link-btn brown-btn">Evaluation Process</a>
                </section>
                <ResultsAnalysis />
              </div>
            </Col>
          </Row>
        </>
      ) : (
        page && (
          <>
            <Row>
              <Col>
                <h1 className="mb-4">{page.title}</h1>
              </Col>
            </Row>
            <Row>
              <Col md={8}>
                <div className="content-area">
                  <div dangerouslySetInnerHTML={{ __html: page.content }} />
                </div>
              </Col>
              <Col md={4}>
                <div className="sidebar">
                  <h3 className="sidebar-title">Quick Links</h3>
                  <section className="quick-links-widget">
                    <a href="http://203.129.197.28/students/studentlogin.aspx" target="_blank" className="quick-link-btn primary">UG Student Portal Login</a>
                    <a href="http://203.129.197.28//STUDENTS/PG/LOGIN.ASPX" target="_blank" className="quick-link-btn secondary">PG Student Portal Login</a>
                    <a href="#" className="quick-link-btn brown-btn">Student online Services</a>
                    <a href="#" className="quick-link-btn brown-btn">Course Structure</a>
                    <a href="#" className="quick-link-btn brown-btn">Evaluation Process</a>
                  </section>
                 <ResultsAnalysis />
                </div>
              </Col>
            </Row>
          </>
        )
      )}
    </Container>
  );
};

export default ContentPage;
